addEventListener('change', ({ target }) => {
  if (target.matches('.job-signup input[type="checkbox"]')) {
    target.closest('.job-signup').querySelector('.help-block input[type="text"]').disabled = !target.checked
  }
})

addEventListener('submit', e => {
  if (e.target.matches('#person-search-form')) {
    e.preventDefault()

    fetch(`${e.target.action}?${new URLSearchParams(new FormData(e.target))}`)
      .then(resp => {
        if (resp.ok) return resp.text()
      })
      .then(text => {
        document.querySelector('#person-results').innerHTML = text
      })
  }
})
